import { createFileRoute } from "@tanstack/react-router";
import Invoices from "@/components/Invoices";

function RouteComponent() {
  return <Invoices />;
}

export const Route = createFileRoute("/_authenticated/invoices/")({
  component: RouteComponent,
  staticData: { page: ["finance", "deals"] },
});
